
export class TestResultFilter {
  constructor() {
    this.applicationStatus = null
    this.applicationType = null
    this.courseNumberFrom = null
    this.courseNumberTo = null
    this.curator = null
    this.educationFormTo = null
    this.expirationReason = null
    this.group = null
    this.organizationFrom = null
    this.paidFormFrom = null
    this.personalData = null
    this.specialityFrom = null
    this.specialityTo = null
    this.paidFormTo = null
  }
}
